import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logoSita from "../../assets/logo_sita.png";
import { APP_NAME } from "../../constant/constant";
import BackButton from "./BackButton";
import LanguageSelect from "../LanguageSelect";
import "./AuthPages.css";

// Shared frame for the login / sign-up flow: logo on a blue header, then a white card
export const AuthLayout = ({ icon, title, subtitle, showBack, children, footer }) => (
  <div className="auth-page">
    <div className="auth-top">
      <div className="auth-toolbar">
        {showBack ? <BackButton /> : <span className="auth-toolbar-spacer" />}
        <LanguageSelect variant="glass" className="auth-language" />
      </div>
      <img className="auth-logo" src={logoSita} alt={`${APP_NAME} logo`} />
    </div>
    <div className="auth-card">
      <div className="auth-icon" aria-hidden="true">
        <FontAwesomeIcon icon={icon} />
      </div>
      <h1 className="auth-title">{title}</h1>
      <p className="auth-subtitle">{subtitle}</p>
      {children}
      {footer && <p className="auth-footer">{footer}</p>}
    </div>
  </div>
);

// Text field with a leading icon
export const AuthField = ({ icon, ...inputProps }) => (
  <label className="auth-field">
    <FontAwesomeIcon icon={icon} className="auth-field-icon" />
    <input className="auth-input" {...inputProps} />
  </label>
);

// One box per digit. Keeps the `${name}-${index}` ids the pages use to move focus to the next box.
export const PinInputs = ({ label, name, values, type, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className="auth-pin-group">
      {label && <span className="auth-pin-label">{label}</span>}
      <div className="auth-pins">
        {values.map((value, index) => (
          <input
            key={index}
            id={`${name}-${index}`}
            className="auth-pin"
            type={type}
            inputMode="numeric"
            autoComplete="off"
            maxLength="1"
            aria-label={`${label || t("auth.digit")} ${index + 1}`}
            value={value}
            onChange={(e) => onChange(index, e.target.value, name)}
          />
        ))}
      </div>
    </div>
  );
};
